import { type ReactNode } from "react";
import { Box, styled } from "~/common/mui";

type Position = "left" | "right" | "top" | "bottom";
interface Props {
  className?: string;
  tailPosition?: Position;
  children?: ReactNode;
}

const Bubble = styled("div")(({ theme }) => ({
  display: "flex",
  position: "relative",
  background: theme.palette.surface.main,
  padding: theme.spacing(2),
  borderColor: theme.palette.surface.main,
  borderRadius: "4px",
  "--bubble-tip-height": "8px",
  "--bubble-tip-width": "20px",
  "--bubble-color": theme.palette.surface.main,
  "&::after": {
    content: '""',
    position: "absolute",
  },
}));

const getTailSx = (position: Position) => {
  switch (position) {
    case "bottom":
      return {
        "&::after": {
          top: "100%",
          left: "calc(50% - (var(--bubble-tip-width) / 2))",
          borderTop: "var(--bubble-tip-height) solid",
          borderTopColor: "inherit",
          borderLeft: "calc(var(--bubble-tip-width) / 2) solid transparent",
          borderRight: "calc(var(--bubble-tip-width) / 2) solid transparent",
        },
      };
    case "top":
      return {
        "&::after": {
          bottom: "100%",
          left: "calc(50% - (var(--bubble-tip-width) / 2))",
          borderBottom: "var(--bubble-tip-height) solid",
          borderBottomColor: "inherit",
          borderLeft: "calc(var(--bubble-tip-width) / 2) solid transparent",
          borderRight: "calc(var(--bubble-tip-width) / 2) solid transparent",
        },
      };
    case "left":
      return {
        "&::after": {
          right: "100%",
          top: "calc(50% - (var(--bubble-tip-width) / 2))",
          borderRight: "var(--bubble-tip-height) solid",
          borderRightColor: "inherit",
          borderTop: "calc(var(--bubble-tip-width) / 2) solid transparent",
          borderBottom: "calc(var(--bubble-tip-width) / 2) solid transparent",
        },
      };
    case "right":
      return {
        "&::after": {
          left: "100%",
          top: "calc(50% - (var(--bubble-tip-width) / 2))",
          borderLeft: "var(--bubble-tip-height) solid",
          borderLeftColor: "inherit",
          borderTop: "calc(var(--bubble-tip-width) / 2) solid transparent",
          borderBottom: "calc(var(--bubble-tip-width) / 2) solid transparent",
        },
      };
  }
};

export const SpeechBubble = ({ className, tailPosition = "top", children }: Props) => {
  return (
    <Box className={className} sx={{ display: "flex" }}>
      <Bubble sx={getTailSx(tailPosition)}>{children}</Bubble>
    </Box>
  );
};
